import mediaBreakpoints from './mediaBreakpoints';

export const xs = window.matchMedia(`(${mediaBreakpoints.mobileOnly})`);

export const sm = window.matchMedia(`(${mediaBreakpoints.phablet})`);

export const md = window.matchMedia(`(${mediaBreakpoints.tablet})`);

export const lg = window.matchMedia(`(${mediaBreakpoints.desktop})`);

export const xl = window.matchMedia(`(${mediaBreakpoints.largeDesktop})`);

export const xxl = window.matchMedia(`(${mediaBreakpoints.xLargeDesktop})`);

const mediaQueries = {
    xs,
    sm,
    md,
    lg,
    xl,
    xxl,
};

export default mediaQueries;
